<template>
  <el-table :data="list" size="small">
    <el-table-column
      prop="experimenter"
      align="center"
      label="实验人"
    ></el-table-column>
    <el-table-column
      prop="day"
      align="center"
      label="实验日期"
    ></el-table-column>
    <el-table-column
      prop="order_number"
      align="center"
      label="单号"
    ></el-table-column>
    <el-table-column
      prop="drill_tool_category"
      align="center"
      label="钻具类型"
    ></el-table-column>
    <el-table-column align="center" label="操作">
      <template slot-scope="scope">
        <el-popconfirm
          v-code="91104"
          title="确定删除该实验吗？"
          @confirm="handleDelete(scope.row.id, scope.$index)"
        >
          <el-button
            slot="reference"
            type="text"
            size="mini"
            class="text-danger mr-10"
            >删除</el-button
          >
        </el-popconfirm>
        <el-button
          v-code="91103"
          type="text"
          size="mini"
          @click="$router.push(`/experiment/experiments/${scope.row.id}/edit`)"
          >编辑</el-button
        >
        <el-button
          v-code="91102"
          type="text"
          size="mini"
          @click="$router.push(`/experiment/experiments/${scope.row.id}`)"
          >详情</el-button
        >
      </template>
    </el-table-column>
  </el-table>
</template>

<script>
import { experimentDelete } from '@/service/getData'
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    async handleDelete(id, index) {
      let res = await experimentDelete(id)
      if (res.code == 0) {
        this.list.splice(index, 1)
      }
    },
  },
}
</script>